import script from "./Calling-Group.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calling-Group.vue?vue&type=script&setup=true&lang=ts"

import "./Calling-Group.vue?vue&type=style&index=0&id=41985a3e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41985a3e"]])

export default __exports__